import { ObjectOrVoid, Url, BaseRoute, PathBuilder } from '../common';

export const MOBILE_APP_URL_PREFIX = 'digitalstack://app';

/**
 * A route (URL) to access the mobile app from the server.
 */
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export class MobileRoute<TParams extends ObjectOrVoid = {}, TQuery extends object = {}> extends BaseRoute<
    TParams,
    TQuery,
    Url
> {
    protected readonly pathBuilder: PathBuilder<TParams>;

    public constructor(pathBuildingFunction: (path: PathBuilder<TParams>) => PathBuilder<TParams>) {
        super(MOBILE_APP_URL_PREFIX, pathBuildingFunction);
        this.pathBuilder = pathBuildingFunction(new PathBuilder<TParams>(MOBILE_APP_URL_PREFIX));
    }

    public hostRoute(): Url {
        return this.pathBuilder.build({ omitPrefix: true }) as Url;
    }
}

export const MobileRoutes = {
    // eslint-disable-next-line @typescript-eslint/no-empty-object-type
    instagramPostReady: new MobileRoute<{ key: string }, {}>(path => path.literal('post').param('key')),
    // eslint-disable-next-line @typescript-eslint/no-empty-object-type
    notification: new MobileRoute<{ inAppNotificationId: number }, {}>(path =>
        path.literal('notification').param('inAppNotificationId'),
    ),
    // eslint-disable-next-line @typescript-eslint/no-empty-object-type
    videoDownloadReady: new MobileRoute<{} | undefined, { videoUrl: Url }>(path =>
        path.literal('video').literal('download'),
    ),
};
